module.exports = ".table tr td {\n}\n\np.error {\n  color: red;\n}\n\n.criteria tr td {\n  width: 50%\n}\n\n.popover {\n  display: block !important;\n  max-width: 500px !important;\n}\n\n.numberCol{\n  text-align:right;\n  vertical-align:baseline;\n}\n\n.numberEdit{\n  width:80px;\n}\n\ntr.lastRow td{\n  padding-bottom:40px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/quota-viewer/quota-viewer.component.css
// module id = ./src/app/components/quota-viewer/quota-viewer.component.css
// module chunks = main